import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { tokens } from '../../../theme'
import MoreVertIcon from '@mui/icons-material/MoreVert';

function AdminBox({ admin, updateAdmin, updateAdminPassword, removeAdmin }) {
    const colors = tokens();
    const [selectedLanguage, setSelectedLanguage] = useState("turkish");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box width="700px">
            <Menu
                id="menu"
                aria-labelledby="open-menu-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem onClick={() => {
                    handleClose();
                    updateAdmin(admin);
                }}>
                    Edit
                </MenuItem>
                <MenuItem onClick={() => {
                    handleClose();
                    updateAdminPassword(admin);
                }}>
                    Edit Password
                </MenuItem>
                <MenuItem onClick={() => {
                    handleClose()
                    removeAdmin(admin);
                }}>
                    Remove
                </MenuItem>
            </Menu>
            <Box position="relative" bgcolor={colors.grey[900]} p="20px" borderRadius="10px">
                <Box position="absolute" top={15} right={15}>
                    <IconButton
                        id="open-menu-button"
                        aria-controls={open ? 'menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>
                        <MoreVertIcon sx={{ scale: "1.2" }} />
                    </IconButton>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography variant='h3' fontWeight="600">
                        {admin.username ? admin.username : "-"}
                    </Typography>
                </Box>
                <Box component="hr" my="20px" border={"1px solid " + colors.grey[500]} />
                <Box mt="10px">
                    <Box display="flex" justifyContent="space-between" mt="10px">
                        <Box>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-User Page Permission:</b> {admin.users_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Words Page Permission:</b> {admin.words_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Questions Page Permission:</b> {admin.questions_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Word Sets Page Permission:</b> {admin.wordsets_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Update Announcements Page Permission:</b> {admin.update_announcements_perm ? "Yes" : "No"}</Typography>
                        </Box>
                        <Box>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Announcements Page Permission:</b> {admin.announcements_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Notifications Permission:</b> {admin.notifications_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Settings Permission:</b> {admin.settings_perm ? "Yes" : "No"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Admins Permission:</b> {admin.admins_perm ? "Yes" : "No"}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default AdminBox